import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'reactstrap';
import { useSelector } from 'react-redux';

import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
// core components
const ModalCDO = ({
  show,
  children,
  onModalToggle,
  title = '',
  subtitle = '',
  showCloseButton = true,
  modalContainerClasses = '',
  modalHeaderClasses = '',
  modalBodyClasses = '',
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    onModalToggle(open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const toggleModal = () => setOpen(!open);

  return (
    <>
      <Modal
        className={`modal-dialog-centered ${modalContainerClasses}`}
        isOpen={open}
        toggle={() => toggleModal()}
        centered={true}
        size="lg"
        style={{ width: '570px', maxHeight: '45rem' }}
        {...props}
      >
        <div
          className={`modal-header ${modalHeaderClasses}`}
          style={{ width: '570px', maxHeight: '45rem' }}
        >
          <h6 className="modal-title" id="modal-title-default">
            {title}
            <br />
            {subtitle && <p>{subtitle}</p>}
          </h6>

          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setOpen(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className={`modal-body ${modalBodyClasses}`}>
          {children}

          {showCloseButton && (
            <div className="modal-footer">
              <Button
                style={buttonStyle(
                  systemConfiguration.cancelation_button_color
                )}
                className="ml-auto"
                data-dismiss="modal"
                type="button"
                onClick={() => toggleModal()}
              >
                Fechar
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ModalCDO;
